import React = require('react');
import { classes } from 'typestyle';
import { Messages } from '../../codegen/Localize';
import { ButtonWidget, ButtonType, TextFieldWidget } from '@tableau/widgets';
import { FileDragAndDrop, preventDefaultDrag } from '../../uploadContent/components/FileDragAndDrop';
import { BulkImportUserDialogStyle } from './styles/BulkImportUserDialogStyle';

export interface FileInputProps{
  // a unique id to link the label to the file input
  fileUploadId?: string;
  // the path of the selected file
  fileName: string;

  handleFileInput(file: File): void;

  testId: string;
}

export interface FileInputStates{
    readonly fileName: string;
}

export class FileInput extends React.PureComponent<FileInputProps, FileInputStates>{
    private fileInput: React.RefObject<HTMLInputElement>;
    constructor(props: FileInputProps) {
        super(props);
        this.fileInput = React.createRef();
        this.state = {
            fileName: '',
        };
    }
    public render() {

        return (
            <div className={BulkImportUserDialogStyle.fileInput}>
                <div>
                    <input
                        type="file"
                        id={this.props.fileUploadId ? this.props.fileUploadId : ' '}
                        ref={this.fileInput}
                        style={{ display: 'none'}}
                        onChange={this.handleFileInputChange}
                    />
                    <FileDragAndDrop
                        handleDrop={(event: React.ChangeEvent<HTMLInputElement>) => this.handleFileInputChange(event)}
                        containerClassName={BulkImportUserDialogStyle.dragAndDropContainer}
                        defaultStateClassName={BulkImportUserDialogStyle.defaultOutline}
                        activeStateClassName={BulkImportUserDialogStyle.activeOutline}
                        onDragClassName={BulkImportUserDialogStyle.focusOutline}
                        testId="bulk-import-user-dialog-file"
                    >
                        <div className={BulkImportUserDialogStyle.dragAndDropChildren} onDragLeave={preventDefaultDrag}>
                            {this.state.fileName &&
                                <b className={BulkImportUserDialogStyle.fileName}>{this.state.fileName}</b>
                            }
                            {!this.state.fileName &&
                                <>
                                    <p className={BulkImportUserDialogStyle.dragAndDropText}>{Messages.contentUpload_dragAndDrop()}</p>
                                    <p className={BulkImportUserDialogStyle.dragAndDropOrText}>{Messages.contentUpload_dragAndDropOr()}</p>{}
                                </>
                            }
                            <ButtonWidget
                                buttonType={ButtonType.Outline}
                                type="button"
                                testId="import-user-browse"
                                children={Messages.contentUpload_chooseAFile()}
                                handleClick={this.triggerFileInput}
                            />
                        </div>
                    </FileDragAndDrop>
                </div>
            </div>
        );
    }

    private handleFileInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if(event.target.files.length > 0) {
            const fileInput: File = event.target.files[0];
            const name = fileInput.name.split('\\').pop();
            this.setState({fileName: name});
            this.props.handleFileInput(fileInput);
        } else{
            this.setState({fileName: ''});
            this.props.handleFileInput(null);
        }
    }

    private triggerFileInput = () => {
        this.fileInput.current.click();
    }

}